<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <valuation-events-grid [hidden]="!showGrid" [workspace]="this"></valuation-events-grid>
    <valuation-events-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                           [workspace]="this"
                           [parent]="parent"
                           [childMode]="childMode"
                           [showPrevBtn]="previousButtonEnabled"
                           [showNextBtn]="nextButtonEnabled"
                           (showPrevious)="showPrevious()"
                           (showNext)="showNext()">
    </valuation-events-form>
  </div>
</div>
<import-wizard *ngIf="showImport && importData" [projectId]="importData.projectId" [oid]="importData.oid" (closePane)="closeAllPanes()"></import-wizard>
<export-wizard *ngIf="showExport && exportData" [projectId]="exportData.projectId" [oid]="exportData.oid" (closePane)="closeAllPanes()"></export-wizard>

<ng-container *ngIf="grid">
  <valuation-event-properties *ngIf="grid.selectedItem && showPropertiesPane"
                              [portfolioOid]=" grid.selectedItem.Oid"
                              [canClose]="true"
                              [compsOptions]="false"
                              (closePane)="closeAllPanes()"
                              [detailForm]="false">
  </valuation-event-properties>

  <valuation-event-participants *ngIf="showParticipantsPane"
                                [canClose]="true"
                                (closePane)="closeAllPanes()">
  </valuation-event-participants>

  <valuation-event-currencies *ngIf="showCurrenciesPane"
                              [canClose]="true"
                              (closePane)="closeAllPanes()">
  </valuation-event-currencies>
</ng-container>

